var React = require('react');

function Ball27 (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-41.5)"},[React.createElement("path",{"d":"M85.864,41,84.5,45.39h2.792L85.908,41Z","transform":"translate(-28.512 -27.154)","key":0}),React.createElement("path",{"d":"M206.364,239,205,243.39h2.792L206.408,239Z","transform":"translate(-108.444 -158.591)","key":1}),React.createElement("path",{"d":"M113.553,6.733A6.733,6.733,0,0,0,106.833,0h-58.6A6.733,6.733,0,0,0,41.5,6.733V93.267A6.733,6.733,0,0,0,48.233,100h58.6a6.733,6.733,0,0,0,6.733-6.733ZM59.3,19.867H55.43l-.75,2.357H52.443l3.8-11.11h2.267l3.783,11.11H60.053Zm2.8,29.88,15.533-20.4,15.53,20.4-15.533,20.4ZM100.627,88.89l-.75-2.357H96l-.75,2.357H93.017l3.8-11.11H99.08l3.783,11.11Z","transform":"translate(0)","key":2})]));
}

Ball27.defaultProps = {"viewBox":"0 0 72.067 100"};

module.exports = Ball27;

Ball27.default = Ball27;
